/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Sociaalemotioneeldoelformulering_Ikvind6Inputs */

const nl_enums_sociaalemotioneeldoelformulering_ikvind6 = /** @type {(inputs: Enums_Sociaalemotioneeldoelformulering_Ikvind6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik vind`)
};

/**

* @param {Enums_Sociaalemotioneeldoelformulering_Ikvind6Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_sociaalemotioneeldoelformulering_ikvind6 = /** @type {((inputs?: Enums_Sociaalemotioneeldoelformulering_Ikvind6Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Sociaalemotioneeldoelformulering_Ikvind6Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_sociaalemotioneeldoelformulering_ikvind6(inputs)
});
export { enums_sociaalemotioneeldoelformulering_ikvind6 as "enums.SociaalEmotioneelDoelFormulering.IkVind" }